import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../../shared/shared.module';
import { DistribuidorRoutingModule } from './distribuidores-routing.module';
import { HomeDistribuidorComponent } from './views/home-distribuidor/home-distribuidor.component';
import { UploadCsvDisComponent } from './views/upload-csv-dis/upload-csv-dis.component';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UploadCsvPresupuestoComponent } from './views/upload-csv-presupuesto/upload-csv-presupuesto.component';
import { UploadCsvRutaComponent } from './views/upload-csv-ruta/upload-csv-ruta.component';
import { DownloadFileComponent } from './views/download-file/download-file.component';
import { MantenedorDistribuidorComponent } from './views/mantenedor-distribuidor/mantenedor-distribuidor.component';
import { ReportePresupuestoComponent } from './views/reporte-presupuesto/reporte-presupuesto.component';
import { ExportCsvComponent } from './views/export-csv/export-csv.component';
import { UploadCsvSellinComponent } from './views/upload-csv-sellin/upload-csv-sellin.component';
import { ReportePresupuestoSellInComponent } from './views/reporte-presupuesto-sell-in/reporte-presupuesto-sell-in.component';


@NgModule({
    declarations: [
      HomeDistribuidorComponent,
      UploadCsvDisComponent,
      UploadCsvPresupuestoComponent,
      UploadCsvRutaComponent,
      DownloadFileComponent,
      MantenedorDistribuidorComponent,
      ReportePresupuestoComponent,
      ExportCsvComponent,
      UploadCsvSellinComponent,
      ReportePresupuestoSellInComponent
    ],
    exports: [
      HomeDistribuidorComponent
    ],
    imports: [
      CommonModule,
      DistribuidorRoutingModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    ]
  })
  
export class DistribuidorModule {}